import { NgModule} from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import {StandardDialogComponent} from './models/standardDialog/standardDialog.components';
import {SperrDialogComponent} from './models/sperrDialog/sperrDialog.components';
import {MaterialModule} from '../../../assets/material.module';
import {DialogVerwaltungsService} from './services/dialogVerwaltungs.service';
import {OptionsDialogComponent} from './models/optionsDialog/optionsDialog.components';


@NgModule({
  imports: [
    BrowserModule,
    CommonModule,
    RouterModule,
    FormsModule,
    ReactiveFormsModule,
    MaterialModule,
  ],
  declarations: [
    StandardDialogComponent,
    SperrDialogComponent,
    OptionsDialogComponent,
  ],
  exports: [
    StandardDialogComponent,
    SperrDialogComponent,
    OptionsDialogComponent,
  ],
  providers: [
    DialogVerwaltungsService,
  ]
})
export class DialogModule { }
